export default {
	BAD: 1,
	ACCEPTABLE: 2,
	GOOD: 3,
};
